<div class="card-container-shadow container-table" [ngStyle]="{'height': 'auto', 'overflow': 'auto'}">
  <nz-table
    *ngIf="mealPlans"
    nzTableHeaderStyle
    [nzData]="mealPlans"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '950px', y: (maxVisibleRows * 44) + 'px'}"
    nzSize="small">
    <thead>
      <tr class="header" style="height: 50px;">
        <th nzWidth="150px" style="height: 50px;">FECHA</th>
        <th nzWidth="300px" style="height: 50px;">PLAN DE ALIMENTACIÓN</th>
        <th nzWidth="300px" style="height: 50px;">CITA</th>
        <th nzWidth="300px" style="height: 50px;">NÚMERO DE CITA</th>
        <th [nzWidth]="'50px'" style="height: 50px;" [nzRight]="mealPlans.length > 0 ? true : false"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mealPlans; index as i">
        <td>{{ item.createdAt | date }}
        </td>
        <td>
          {{ item.name }}
        </td>
        <td>
          <div *ngIf="item.mealPlanAppointment">
            <p class="text-info-sm opacity-70">{{item.mealPlanAppointment?.type | getTypeAppointment}}</p>
            <p class="text-info-bold mt-xxs">
              <span>{{ item.mealPlanAppointment.startDate.date | date:'fullDate' }} - </span>
              <span>
                {{ item.mealPlanAppointment.startDate.date?.getHours() > 12 ? item.mealPlanAppointment.startDate.date?.getHours() - 12 :
                item.mealPlanAppointment.startDate.date?.getHours()}}:{{ item.mealPlanAppointment.startDate.date?.getMinutes() === 0 ? '00' :
                item.mealPlanAppointment.startDate.date?.getMinutes() }}
                {{ item.mealPlanAppointment.startDate.date?.getHours() >= 12 ? ' PM' : ' AM' }}
              </span>
            </p>
          </div>
          <div *ngIf="!item.mealPlanAppointment">
            <p class="text-info">No está asignado a ninguna cita.</p>
          </div>
        </td>
        <td>
          {{ item.mealPlanAppointment ? item.mealPlanAppointment?.appointmentNumber : '-' }}
        </td>
        <td nzRight>
          <div class="action-column">
            <div class="more-options">
              <div class="more" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
                <i nz-icon nzType="ellipsis" nzTheme="outline"></i>
              </div>
            </div>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li nz-menu-item *ngIf="this.userType === 'expert'" (click)="onEmmitSelectOptionMealPlan(optionsMealPlanTableEmitEnum.SHOW, item._id)">
                  <i style="margin-right: 5px;" nz-icon nzType="arrow-right" nzTheme="outline"></i>
                  Abrir plan de alimentación
                </li>
                <li nz-menu-item *ngIf="this.userType === 'expert'" (click)="onEmmitSelectOptionMealPlan(optionsMealPlanTableEmitEnum.USE, item._id)">
                  <i style="margin-right: 5px;" nz-icon nzType="check-circle" nzTheme="outline"></i>
                  Usar este plan de alimentación
                </li>
                <li nz-menu-item (click)="onEmmitSelectOptionMealPlan(optionsMealPlanTableEmitEnum.DOWNLOAD, item._id)">
                  <i style="margin-right: 5px;" nz-icon nzType="cloud-download" nzTheme="outline"></i>
                  Descargar plan de alimentación
                </li>
                <li nz-menu-divider *ngIf="this.userType === 'expert'"></li>
                <li nz-menu-item nzDanger (click)="onEmmitSelectOptionMealPlan(optionsMealPlanTableEmitEnum.DELETE, item._id)"
                  *ngIf="userLogged.experts">
                  <i style="margin-right: 5px;" nz-icon nzType="delete" nzTheme="outline"></i>
                  Eliminar
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
